export default {"src":"/uk/_next/static/media/worldwide.7195791b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};